import { useQuery } from '@tanstack/react-query';
import { partnerService } from '../services/partner.service';

export function usePartnerDashboard(enabled = true) {
  return useQuery({
    queryKey: ['partner', 'dashboard'],
    queryFn: () => partnerService.getDashboard(),
    retry: false,
    staleTime: 1000 * 60,
    enabled,
  });
}

export function usePartnerBalance(enabled = true) {
  return useQuery({
    queryKey: ['partner', 'balance'],
    queryFn: () => partnerService.getBalance(),
    retry: false,
    staleTime: 1000 * 60 * 2,
    enabled,
  });
}

export function usePartnerStats(period?: string, enabled = true) {
  return useQuery({
    queryKey: ['partner', 'stats', period],
    queryFn: () => partnerService.getStats(period),
    retry: false,
    staleTime: 1000 * 60 * 5,
    enabled,
  });
}
